<ng-template #specUp let-modal>
	<div class="modal-header">
		<h3> Upload New Specials </h3>
	</div>
	<div class="modal-body text-dark specials-upload-modal-body">
		<ng-container *ngIf="!uploaddata.rows">
			<div class="row text-center w-100 ml-auto mr-auto">
				<ngx-dropzone [multiple]="false" (change)="onSelect($event)">
					<ngx-dropzone-label class="m-2">
						DROP FILE HERE OR CLICK TO UPLOAD
					</ngx-dropzone-label>
					<ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)">
						<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
					</ngx-dropzone-preview>
				</ngx-dropzone>
			</div>
		</ng-container>
		<ng-container *ngIf="uploaddata.rows">
			<p class="specials-upload-intro mb-3">
				Map each value the import needs to a column from your file. Context columns (brand, description, etc.) stay in the file but do not need a mapping.
			</p>
			<div class="specials-upload-layout">
				<div class="specials-upload-mapping">
					<div class="specials-upload-actions">
						<button mat-stroked-button color="primary" type="button" (click)="applyUploadColumnGuesses()">
							<mat-icon>auto_fix_high</mat-icon>
							Auto-map columns
						</button>
						<button mat-flat-button color="primary" type="button" aria-label="Apply upload" (click)="sendSpecials()">
							<mat-icon>cloud_upload</mat-icon>
							Update
						</button>
					</div>
					<div class="specials-upload-field-rows">
						<div class="specials-upload-field-row" *ngFor="let mc of mapcols">
							<span class="specials-upload-field-label">{{ mc.label }}</span>
							<mat-form-field appearance="outline" class="specials-upload-field-select">
								<mat-label>File column</mat-label>
								<mat-select
									[value]="uploadSourceByField[mc.field] || ''"
									(valueChange)="onUploadSourceChange(mc.field, $event)"
								>
									<mat-option value="">— Not used —</mat-option>
									<mat-option *ngFor="let h of uploaddata.header" [value]="h">{{ h }}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
				</div>
				<div class="specials-upload-preview" *ngIf="uploadMappedPreviewHeaders.length">
					<h4 class="specials-upload-preview-title">Preview (mapped columns, first {{ uploadPreviewRows.length }} rows)</h4>
					<div class="specials-upload-preview-scroll">
						<table class="table table-sm table-bordered mb-0">
							<thead>
								<tr>
									<th *ngFor="let h of uploadMappedPreviewHeaders">{{ h }}</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let row of uploadPreviewRows">
									<td *ngFor="let h of uploadMappedPreviewHeaders">{{ row[h] }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #specEdit let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Edit</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<h4 class="title mb-3" *ngIf="itemdetails">{{ itemdetails.item.stockid }} — {{ itemdetails.item.description }}</h4>
		<form [formGroup]="specialForm" class="text-center">
					<div class="row">
						<div class="col-6">
							<mat-form-field appearance="outline">
								<mat-label>Part Number</mat-label>

								<input (change)="autocompleteFilter()" (keyup.enter)="$event.preventDefault();" (input)="autocompleteFilter()" type="text" class="text-left " matInput formControlName="stockid" [matAutocomplete]="stocksuggest" />
								<mat-autocomplete autoActiveFirstOption #stocksuggest="matAutocomplete">
									<mat-option *ngFor="let item of filteredOptions" [value]="item.stockid" (click)="selectItem(item.stockid)">
										{{item.stockid }} {{ item.description}}
									</mat-option>
								</mat-autocomplete>
							</mat-form-field>
						</div>
						<div class="col-6">
							<mat-form-field appearance="outline">
								<mat-label>Qty Limit</mat-label>
								<input type="text" class="text-right" matInput formControlName="qtylimit" />
								<span matSuffix class="text-danger">&nbsp;&nbsp;&nbsp;QOH {{ itemdetails.total_qoh }} </span>
							</mat-form-field>

						</div>
				

						<div class="col-12 mt-3v">
							<mat-slide-toggle formControlName="nfd" class="mr-1">
									<mat-label>No Additional Discounts</mat-label>
								</mat-slide-toggle>
							<span *ngIf="editing">
								<mat-slide-toggle formControlName="clearsold" class="mr-1">
									<mat-label>Clear Qty Sold</mat-label>
								</mat-slide-toggle>
								&nbsp;&nbsp;&nbsp;
							</span>
							
							


							<mat-radio-group aria-label="AND QTY LIMIT" formControlName="andor" class="text-center" (change)="setValiditiy()">
								<mat-radio-button value="1">DATE LIMIT</mat-radio-button>
								&nbsp;&nbsp;&nbsp;
								<mat-radio-button value="2">QTY LIMIT</mat-radio-button>
							</mat-radio-group>
						</div>
						<div class="col-2">
						
						</div>
						<div class="col-3">
							<mat-form-field appearance="outline">
								<mat-label>Start Date</mat-label>
								<input matInput [matDatepicker]="picker1" formControlName="startdate" />
								<mat-datepicker-toggle matSuffix [for]="picker1">
								</mat-datepicker-toggle>
								<mat-datepicker #picker1></mat-datepicker>
							</mat-form-field>
						</div>
						<div class="col-2">
						</div>
						<div class="col-3">
							<mat-form-field appearance="outline">
								<mat-label>End Date</mat-label>
								<input matInput [matDatepicker]="picker2" formControlName="enddate" />
								<mat-datepicker-toggle matSuffix [for]="picker2">
								</mat-datepicker-toggle>
								<mat-datepicker #picker2></mat-datepicker>
							</mat-form-field>
						</div>
						<div class="col-2">
						</div>
					</div>
					<div class="row">
						<div class="col-4 ml-auto mr-auto">
							<mat-form-field appearance="outline">
								<span matPrefix>$&nbsp;&nbsp;</span>
								<mat-label>Blanket Price</mat-label>
								<input type="text" class="text-right " matInput [formControl]="blanket"/>
							</mat-form-field>
						</div>
					</div>

					<div class="row m-0 p-0 d-flex justify-content-center">

						<div class="col-auto" *ngFor="let x of prices_array;let i = index">
							<mat-form-field appearance="outline">
								<mat-label>{{ x.sales_type }}</mat-label>
								<input type="text" class="text-right " matInput [(value)]="x.price" (input)="x.price = $event.target.value;"/>
								<!-- <mat-hint *ngIf="editing"> {{ original_prices_array[i].price }} </mat-hint> -->
							</mat-form-field>
						</div>
					</div>

					
					<button mat-stroked-button color="success" aria-label="" (click)="saveSpecial()" class="mt-2">
						<mat-icon>save</mat-icon> Save
					</button>

					<div class="row m-0 p-0 w-100 text-center mt-3 mb-1 justify-content-center" *ngIf="config.env.package == 'tires'" >
						<mat-label >
							<span class="italics font-weight-lighter mt-1 mb-1 ml-0 mr-0">
								<ng-container *ngIf="specialForm.get('andor').value == 1">On special when in the date range regardless of availabilty</ng-container>
								<ng-container *ngIf="specialForm.get('andor').value == 2">On special when quantity sold is less than the quantity limit and availabilty is greater than zero</ng-container>
							</span>
						</mat-label>
					</div>
				</form>


	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-container>
	<div class="main-content">
		<div class="container-fluid">
			<div class="row ">
				<div class="col-md-12">
					<div class="card">
						<div class="card-header card-header-{{color}}-3">
							<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Special Pricing</h4>
							<p class="card-category"></p>
						</div>
						<div class="card-body">
							<div class="specials-toolbar">
								<div class="specials-toolbar__actions">
									<button mat-flat-button color="primary" type="button" (click)="$event.preventDefault(); addSpecial()">
										<mat-icon>add</mat-icon>
										Add Special
									</button>
									<button mat-stroked-button type="button" (click)="$event.preventDefault(); uploadSpecial()">
										<mat-icon>cloud_upload</mat-icon>
										Upload
									</button>
									<button mat-stroked-button type="button" [disabled]="!active?.length" (click)="$event.preventDefault(); exportSpecialsXlsx()">
										<mat-icon>table_chart</mat-icon>
										XLSX
									</button>
									<button mat-stroked-button type="button" color="warn" [disabled]="!active?.length" (click)="$event.preventDefault(); exportSpecialsPdf()">
										<mat-icon>picture_as_pdf</mat-icon>
										PDF
									</button>
								</div>
								<div class="specials-toolbar__search">
									<mat-form-field appearance="outline" class="w-100 mb-0">
										<mat-label>Search</mat-label>
										<input matInput [formControl]="searchSpecials" (input)="itemSearch()" placeholder="SKU, description, brand, size, MFG…" />
									</mat-form-field>
								</div>
							</div>

							<div class="specials-filters" [formGroup]="filterForm">
								<div class="specials-filters__layout">
									<div class="specials-filters__group specials-filters__group--brands">
										<div class="specials-filters__group-head">
											<span class="specials-filters__group-title">Brands</span>
											<span
												class="specials-filters__group-badge"
												*ngIf="filterForm.get('brands')?.value?.length as n"
											>
												{{ n }} selected
											</span>
										</div>
										<div class="specials-filters__brands-row">
											<mat-form-field
												appearance="outline"
												class="specials-filters__field specials-filters__field--brands"
												subscriptSizing="dynamic"
											>
												<mat-label>Choose brands</mat-label>
												<mat-select formControlName="brands" multiple placeholder="All brands">
													<mat-option *ngFor="let b of brandOptions" [value]="b">{{ brandLabel(b) }}</mat-option>
												</mat-select>
											</mat-form-field>
											<div class="specials-filters__btn-pair" role="group" aria-label="Brand selection shortcuts">
												<button
													mat-stroked-button
													type="button"
													class="specials-filters__shortcut"
													(click)="selectAllBrands()"
												>
													<mat-icon class="specials-filters__icon-sm">select_all</mat-icon>
													All
												</button>
												<button
													mat-stroked-button
													type="button"
													class="specials-filters__shortcut"
													(click)="selectNoBrands()"
												>
													<mat-icon class="specials-filters__icon-sm">layers_clear</mat-icon>
													None
												</button>
											</div>
										</div>
										<p class="specials-filters__foot" *ngIf="filterForm.get('brands')?.value?.length">
											Only rows for the selected brands are shown.
										</p>
									</div>

									<div class="specials-filters__group specials-filters__group--age">
										<span class="specials-filters__group-title">Age (days)</span>
										<div class="specials-filters__pair">
											<mat-form-field appearance="outline" class="specials-filters__field" subscriptSizing="dynamic">
												<mat-label>Min</mat-label>
												<input matInput type="number" formControlName="ageMin" min="0" />
											</mat-form-field>
											<mat-form-field appearance="outline" class="specials-filters__field" subscriptSizing="dynamic">
												<mat-label>Max</mat-label>
												<input matInput type="number" formControlName="ageMax" min="0" />
											</mat-form-field>
										</div>
									</div>

									<div class="specials-filters__group specials-filters__group--qoh">
										<span class="specials-filters__group-title">Quantity on hand</span>
										<div class="specials-filters__pair">
											<mat-form-field appearance="outline" class="specials-filters__field" subscriptSizing="dynamic">
												<mat-label>Min</mat-label>
												<input matInput type="number" formControlName="qohMin" step="any" />
											</mat-form-field>
											<mat-form-field appearance="outline" class="specials-filters__field" subscriptSizing="dynamic">
												<mat-label>Max</mat-label>
												<input matInput type="number" formControlName="qohMax" step="any" />
											</mat-form-field>
										</div>
									</div>

									<div class="specials-filters__clear-wrap">
										<button
											mat-stroked-button
											type="button"
											color="primary"
											class="specials-filters__clear"
											(click)="clearRangeFilters()"
										>
											<mat-icon>clear</mat-icon>
											Clear age &amp; QOH
										</button>
									</div>
								</div>
							</div>

							<mat-tab-group mat-stretch-tabs="false" color="accent">
								<mat-tab label="Current">
									<div class="tab-pane specials-scroll">
										<table class="specials-table">
											<thead>
												<tr>
													<th class="col-actions"></th>
													<th class="col-stock">Stock</th>
													<th class="col-brand">Brand</th>
													<th class="col-size">Size</th>
													<th class="col-mfgpart">Mfg part</th>
													<th class="col-cat">Cat</th>
													<th class="col-line">Line</th>
													<th>Description</th>
													<th>Dates</th>
													<th class="col-num">Left</th>
													<th class="col-num">QOH</th>
													<th class="col-num">Age</th>
													<th class="col-price leftb" *ngFor="let x of pricelvs">{{ x.sales_type }}</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngIf="active && !active.length" class="text-muted">
													<td class="text-center py-4" [attr.colspan]="12 + (pricelvs?.length || 0)">
														<span *ngIf="allactive?.length">No rows match search or filters.</span>
														<span *ngIf="!allactive?.length">No current specials.</span>
													</td>
												</tr>
												<tr *ngFor="let p of active">
													<td class="col-actions">
														<button mat-icon-button color="warn" type="button" matTooltip="Remove" (click)="removeSpecial(p)">
															<mat-icon>delete_outline</mat-icon>
														</button>
														<button mat-icon-button color="primary" type="button" matTooltip="Edit" (click)="editSpecial(p)">
															<mat-icon>edit</mat-icon>
														</button>
													</td>
													<td class="col-stock">
														<a [routerLink]="['/inventory/view', p.stockid]">{{ p.stockid }}</a>
													</td>
													<td class="col-brand" [title]="p.brand">{{ p.brand || '—' }}</td>
													<td class="col-size" [title]="p.rawsize">{{ p.rawsize || '—' }}</td>
													<td class="col-mfgpart" [title]="p.mfgpart">{{ p.mfgpart || '—' }}</td>
													<td class="col-cat text-muted-cell">{{ p.categoryid || '—' }}</td>
													<td class="col-line text-muted-cell">{{ p.lineid || '—' }}</td>
													<td class="col-desc" [title]="p.description">{{ p.description }}</td>
													<td class="col-dates">
														{{ p.startdate | date: 'shortDate' }}<br />
														<span class="text-muted-cell">{{ p.enddate | date: 'shortDate' }}</span>
													</td>
													<td class="col-num">{{ p.qtyleft }}</td>
													<td class="col-num">{{ p.qoh | number: '1.0-0' }}</td>
													<td class="col-num">{{ p.age }}</td>
													<td class="col-price leftb" *ngFor="let x of pricelvs">
														<ng-container *ngIf="x?.typeabbrev && p?.prices && p.prices[x.typeabbrev]">
															{{ p.prices[x.typeabbrev] | currency }}
														</ng-container>
														<ng-container *ngIf="!(x?.typeabbrev && p?.prices && p.prices[x.typeabbrev])">
															<span class="text-muted-cell">—</span>
														</ng-container>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</mat-tab>
								<mat-tab label="Expired">
									<div class="tab-pane specials-scroll">
										<table class="specials-table">
											<thead>
												<tr>
													<th class="col-actions"></th>
													<th class="col-stock">Stock</th>
													<th class="col-brand">Brand</th>
													<th class="col-size">Size</th>
													<th class="col-mfgpart">Mfg part</th>
													<th class="col-cat">Cat</th>
													<th class="col-line">Line</th>
													<th>Description</th>
													<th>Dates</th>
													<th class="col-num">Left</th>
													<th class="col-price leftb" *ngFor="let x of pricelvs">{{ x.sales_type }}</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngIf="inactive && !inactive.length" class="text-muted">
													<td class="text-center py-4" [attr.colspan]="10 + (pricelvs?.length || 0)">
														<span *ngIf="allinactive?.length">No rows match search or filters.</span>
														<span *ngIf="!allinactive?.length">No expired specials.</span>
													</td>
												</tr>
												<tr *ngFor="let p of inactive">
													<td class="col-actions">
														<button mat-icon-button color="warn" type="button" matTooltip="Remove" (click)="removeSpecial(p)">
															<mat-icon>delete_outline</mat-icon>
														</button>
														<button mat-icon-button color="primary" type="button" matTooltip="Edit" (click)="editSpecial(p)">
															<mat-icon>edit</mat-icon>
														</button>
													</td>
													<td class="col-stock">
														<a [routerLink]="['/inventory/view', p.stockid]">{{ p.stockid }}</a>
													</td>
													<td class="col-brand" [title]="p.brand">{{ p.brand || '—' }}</td>
													<td class="col-size" [title]="p.rawsize">{{ p.rawsize || '—' }}</td>
													<td class="col-mfgpart" [title]="p.mfgpart">{{ p.mfgpart || '—' }}</td>
													<td class="col-cat text-muted-cell">{{ p.categoryid || '—' }}</td>
													<td class="col-line text-muted-cell">{{ p.lineid || '—' }}</td>
													<td class="col-desc" [title]="p.description">{{ p.description }}</td>
													<td class="col-dates">
														{{ p.startdate | date: 'shortDate' }}<br />
														<span class="text-muted-cell">{{ p.enddate | date: 'shortDate' }}</span>
													</td>
													<td class="col-num">{{ p.qtyleft }}</td>
													<td class="col-price leftb" *ngFor="let x of pricelvs">
														<ng-container *ngIf="x?.typeabbrev && p?.prices && p.prices[x.typeabbrev]">
															{{ p.prices[x.typeabbrev] | currency }}
														</ng-container>
														<ng-container *ngIf="!(x?.typeabbrev && p?.prices && p.prices[x.typeabbrev])">
															<span class="text-muted-cell">—</span>
														</ng-container>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</mat-tab>
							</mat-tab-group>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
